import React from 'react';
import classnames from 'classnames';
import Text from '../../../global/text/text';
import { IThemeDTO, Status } from '../../../../api/themes.dao';
import './theme-list-item';
import DefaultButton from '../../../global/default-button/default-button';
import { IntlShape } from 'react-intl';

interface IProps extends IThemeDTO {
    handleEditClick: (title: string, themeId: number) => void;
    intl: IntlShape;
    isSelected?: boolean;
    searchInput?: string;
}

const ThemeListItem = (props: IProps) => {
    const { isSelected, name, status, handleEditClick, intl, id } = props;

    const cellEffectClasses = classnames({
        'active': isSelected,
        'hoverable': !isSelected
    });

    const onEditClick = () => {
        if (status !== Status.Pending) {
            handleEditClick(intl.formatMessage(
                {
                    id: `oe.theme.editTheme`,
                    description: 'Edit theme title',
                    defaultMessage: 'Edit Passport Theme'
                }
            ), id);
        }
    };

    return (
        <tr className='theme-item' onDoubleClick={onEditClick}>
            <td className={classnames(cellEffectClasses)}>
                <div className='theme-item__column'>
                    <Text
                        className='theme-item__text'
                        message={name}
                        withEllipsis
                        withHighlight
                        highlightValue={props.searchInput}
                    />
                </div>
            </td>
            <td className={classnames(cellEffectClasses)}>
                <div className='theme-item__column'>
                    <Text className='theme-item__text' message={status} withEllipsis/>
                </div>
            </td>
            <td className={classnames('align-right', cellEffectClasses)}>
                {
                    status !== Status.Pending &&
                    <DefaultButton
                        className='visible-while-hovered'
                        modifier='slim'
                        text={intl.formatMessage({
                            id: 'oe.common.edit',
                            defaultMessage: 'Edit',
                            description: 'Button text'
                        })}
                        onClick={onEditClick}
                    />
                }
            </td>
        </tr>

    );
};

export { ThemeListItem };
